import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import Store from "./Store";
import Gapi from "./Gapi";

const store = new Store("kostenbladje");
const gapi = new Gapi();

const renderRoot = () => {
    ReactDOM.render(
        <App store={store} gapi={gapi} />,
        document.getElementById("root"),
    );
};

renderRoot();
if (module.hot) {
    module.hot.accept("./App", renderRoot);
}
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js